module.exports = __webpack_public_path__ + "img/lb-ppl.22308b5e.svg";